import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';

export const ModalTitle = ({ children }: { children: React.ReactNode }) => {
  return <DialogTitle id="modal-title">{children}</DialogTitle>;
};
